import React, { Component } from "react";
import { Redirect } from 'react-router-dom';

class LoginErrorCustom extends Component {

    render() {
        return (
            <Redirect to={{
                pathname: '/',
                error: this.props.error
            }} />
        );
    }
}

export default LoginErrorCustom;